import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import {
  DiagnosisLoadingCard,
  DiagnosisLoadingRow,
  DiagnosisLoadingSpinner,
} from 'screens/result/result.styles';

export function DiagnosisLoadingIndicator({ children }: { children?: ReactNode }) {
  const { t } = useTranslation();

  return (
    <DiagnosisLoadingCard>
      <DiagnosisLoadingRow>
        <DiagnosisLoadingSpinner />
        <span>{t('result.diagnosisSection.loading')}</span>
      </DiagnosisLoadingRow>
      {children}
    </DiagnosisLoadingCard>
  );
}
